import { Box, Checkbox, FormControl, FormControlLabel, TextField } from '@mui/material'
import React, { useState, useEffect } from 'react'
import './AdditionalInfo.scss'
import { useSelector, useDispatch } from 'react-redux'
import { changeContact } from '../../../../store/slices/changeContact'
import PaymentModule from '../../PaymentModule/PaymentModule'

export default function AdditionalInfo({ contact, change }) {
  const save = useSelector((state) => state.changeContact.save)
  const reduxContact = useSelector((state) => state.changeContact.currentContact)
  const dispatch = useDispatch()

  const {
    phone,
    iban,
    swift,
    nif,
    cif,
    billAddress,
    instagram,
    email,
    img,
    comArdress,
    mapURI,
    pavilion,
    type,
    hideComment,
    codes,
    logo,
    owner,
    minOrderPrice,
    mapCoords,
  } = contact
  const [phoneValue, setPhoneValue] = useState(phone || '')
  const [ibanValue, setIbanValue] = useState(typeof iban === 'string' ? iban : iban?.[0] || '')
  const [swiftValue, setSwiftValue] = useState(typeof swift === 'string' ? swift : swift?.[0] || '')
  const [nifValue, setNifValue] = useState(typeof nif === 'string' ? nif : nif?.[0] || '')
  const [cifValue, setCifValue] = useState(typeof cif === 'string' ? cif : cif?.[0] || '')
  const [addressValue, setAddressValue] = useState(billAddress?.address || '')
  const [cityValue, setCityValue] = useState(billAddress?.city || '')
  const [instagramValue, setInstagramValue] = useState(instagram || '')
  const [emailValue, setEmailValue] = useState(email || '')
  const [imageValue, setImageValue] = useState(img || '')
  const [comArdressValue, setComArdressValue] = useState(comArdress || '')
  const [mapURIValue, setMapURIValue] = useState(mapURI || '')
  const [pavilionValue, setPavilionValue] = useState(pavilion || '')
  const [locationValue, setLocationValue] = useState(location || '')
  const [hideCommentValue, setHideCommentValue] = useState(hideComment || '')
  const [codesValue, setCodesValue] = useState(codes || '')
  const [logoValue, setLogoValue] = useState(logo || '')
  const [ownerValue, setOwnerValue] = useState(owner || '')
  const [minOrderPriceValue, setMinOrderPriceValue] = useState(minOrderPrice || '')
  const [mapCoordsValue, setMapCoordsValue] = useState(mapCoords || '')

  useEffect(() => {
    if (contact) {
      setPhoneValue(contact.phone || '')
      setIbanValue(typeof iban === 'string' ? iban : contact.iban?.[0] || '')
      setSwiftValue(typeof swift === 'string' ? swift : contact.swift?.[0] || '')
      setNifValue(typeof nif === 'string' ? nif : nif?.[0] || '')
      setCifValue(typeof cif === 'string' ? cif : contact.cif?.[0] || '')
      setAddressValue(contact.billAddress?.address || '')
      setCityValue(contact.billAddress?.city || '')
      setEmailValue(contact.email || '')
      setInstagramValue(contact.instagram || '')
      setImageValue(contact.img || '')
      setComArdressValue(contact.comArdress || '')
      setMapURIValue(contact.mapURI || '')
      setPavilionValue(contact.pavilion || '')
      setLocationValue(contact.location || '')
      setHideCommentValue(contact.hideComment || '')
      setCodesValue(contact.codes || '')
      setLogoValue(contact.logo || '')
      setOwnerValue(contact.owner || '')
      setMinOrderPriceValue(contact.minOrderPrice || '')
      setMapCoordsValue(contact.mapCoords || '')
    }
  }, [contact])

  useEffect(() => {
    if (save) {
      dispatch(
        changeContact({
          phone: phoneValue,
          iban: ibanValue,
          swift: swiftValue,
          nif: nifValue,
          cif: cifValue,
          billAddress: {
            address: addressValue,
            city: cityValue,
          },
          instagram: instagramValue,
          email: emailValue,
          img: imageValue,
          comArdress: comArdressValue,
          mapURI: mapURIValue,
          pavilion: pavilionValue,
          location: locationValue,
          hideComment: hideCommentValue,
          codes: codesValue,
          logo: logoValue,
          owner: ownerValue,
          minOrderPrice: parseInt(minOrderPriceValue),
          mapCoords: mapCoordsValue,
        }),
      )
    }
  }, [save])

  const [error, setError] = useState(false)

  const handleChangeCodeValue = (e) => {
    const input = e.target.value
    setPavilionValue(input)
  }

  return (
    <Box className='additionalInfo__cc'>
      <TextField
        disabled={!change}
        id='outlined-basic'
        label='phone'
        variant='outlined'
        size='small'
        value={phoneValue}
        onChange={(e) => setPhoneValue(e.target.value)}
      />
      <FormControl sx={{ minWidth: 120, display: 'flex', flexDirection: 'row' }}>
        <TextField
          disabled={!change}
          id='outlined-basic'
          label='IBAN'
          variant='outlined'
          size='small'
          value={ibanValue}
          onChange={(e) => setIbanValue(e.target.value)}
        />
        <TextField
          disabled={!change}
          id='outlined-basic'
          label='SWIFT'
          variant='outlined'
          size='small'
          value={swiftValue}
          onChange={(e) => setSwiftValue(e.target.value)}
        />
      </FormControl>
      <TextField
        disabled={!change}
        id='outlined-basic'
        label='Map URI'
        variant='outlined'
        size='small'
        value={mapURIValue}
        onChange={(e) => setMapURIValue(e.target.value)}
      />
      <TextField
        disabled={!change}
        id='outlined-basic'
        label='Map Coords'
        variant='outlined'
        size='small'
        value={mapCoordsValue}
        onChange={(e) => setMapCoordsValue(e.target.value)}
      />
      <FormControl sx={{ minWidth: 120, display: 'flex', flexDirection: 'row' }}>
        <TextField
          disabled={!change}
          id='outlined-basic'
          label='NIF/CIF'
          variant='outlined'
          size='small'
          sx={{ width: '50%' }}
          value={nifValue}
          onChange={(e) => setNifValue(e.target.value)}
        />
        <TextField
          disabled={!change}
          id='outlined-basic'
          label='Comercial address'
          variant='outlined'
          sx={{ width: '50%' }}
          size='small'
          value={comArdressValue}
          onChange={(e) => setComArdressValue(e.target.value)}
        />
      </FormControl>
      <FormControl sx={{ minWidth: 120, display: 'flex', flexDirection: 'row' }}>
        <TextField
          disabled={!change}
          id='outlined-basic'
          label='Legal address'
          variant='outlined'
          size='small'
          sx={{ width: '70%' }}
          value={addressValue}
          onChange={(e) => setAddressValue(e.target.value)}
        />
        <TextField
          disabled={!change}
          id='outlined-basic'
          label='City'
          variant='outlined'
          size='small'
          sx={{ width: '30%' }}
          value={cityValue}
          onChange={(e) => setCityValue(e.target.value)}
        />
      </FormControl>
      <FormControl sx={{ minWidth: 120, display: 'flex', flexDirection: 'row' }}>
        <TextField
          disabled={!change}
          id='outlined-basic'
          label='Instagram'
          variant='outlined'
          size='small'
          sx={{ width: '50%' }}
          value={instagramValue}
          onChange={(e) => setInstagramValue(e.target.value)}
        />
        <TextField
          disabled={!change}
          id='outlined-basic'
          label='Email'
          variant='outlined'
          size='small'
          sx={{ width: '50%' }}
          value={emailValue}
          onChange={(e) => setEmailValue(e.target.value)}
        />
      </FormControl>
      <TextField
        disabled={!change}
        id='outlined-basic'
        label='Image source'
        variant='outlined'
        size='small'
        // sx={{ width: '70%' }}
        value={imageValue}
        onChange={(e) => setImageValue(e.target.value)}
      />
      <TextField
        disabled={!change}
        id='outlined-basic'
        label='Comment'
        variant='outlined'
        size='small'
        multiline
        rows={4}
        sx={{
          height: '120px',
          div: {
            height: '100%',
          },
        }}
        value={hideCommentValue}
        onChange={(e) => setHideCommentValue(e.target.value)}
      />
      {type == 'supplier' && (
        <TextField
          disabled={!change}
          id='outlined-basic'
          label='Pavilions'
          error={error}
          helperText={error ? 'Incorrect format. Exaple: 0000,1234,5678' : ''}
          variant='outlined'
          size='small'
          value={pavilionValue}
          // inputProps={{
          //   inputMode: 'numeric',
          //   pattern: '[0-9,]*',
          // }}
          onChange={handleChangeCodeValue}
        />
      )}
      {type == 'supplier' &&
      <TextField
        disabled={!change}
        id='outlined-basic'
        label='Locations'
        error={error}
        helperText={error ? "Incorrect format. Exaple: 0000,1234,5678" : ""}
        variant='outlined'
        size='small'
        value={locationValue}
        // inputProps={{
        //   inputMode: 'numeric',
        //   pattern: '[0-9,]*',
        // }}
        onChange={(e) => {setLocationValue(e.target.value)}}
      />}
      {type == 'ambassador' && (
        <TextField
          disabled={!change}
          id='outlined-basic'
          label='Codes...'
          variant='outlined'
          size='small'
          value={codesValue}
          onChange={(e) => {
            setCodesValue(e.target.value)
          }}
        />
      )}
      {type == 'ambassador' && (
        <TextField
          disabled={!change}
          id='outlined-basic'
          label='Logo link'
          variant='outlined'
          size='small'
          value={logoValue}
          onChange={(e) => setLogoValue(e.target.value)}
        />
      )}
      {type == 'client' && (
        <TextField
          disabled={!change}
          id='outlined-basic'
          label='Minimal price order'
          variant='outlined'
          size='small'
          type='number'
          value={minOrderPriceValue}
          onChange={(e) => setMinOrderPriceValue(e.target.value)}
        />
      )}
      {type == 'ambassador' && (
        <FormControlLabel
          control={
            <Checkbox
              disabled={!change}
              checked={ownerValue}
              onChange={() => {
                setOwnerValue(!ownerValue)
              }}
            />
          }
          label='Owner'
        />
      )}
      {type == 'client' && <PaymentModule tradeName={contact.tradeName} disabled={!change} />}
    </Box>
  )
}
